// extracted by mini-css-extract-plugin
export default {"wrapper":"view_wrapper__vvfjg"};